import React, { useEffect, useState } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, GridSize, InputLabel, TextField, Typography } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { Controller, useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { styled } from '@mui/material/styles';
import { useStyles } from './styles';
import { theme } from './theme';
import { PPDropDown, PPToggle } from 'processor-plataform-ui';
import "./index.css";

export interface ButtonEventGrid {
    id?: string;
    title: string;
    icon: string;
    disabled?: boolean;
    func: Function;
    skipvalidation?: boolean;
    tooltip?: string;
}

export interface PPRequired {
    required: string;
    value: boolean;
    pattern: PPPattern;
}

export interface PPPattern {
    value: string;
    message: string;
}

export interface PPField {
    edit: boolean;
    row: number;
    col: number;
    colspan: number;
    rowspan: number;
    name: string;
    type: string;
    title: string;
    required: PPRequired;
    description: string;
    id: number;
    order: number;
    disabled: boolean;
    options: Option[];
}

export interface PPFormTemplate {
    title: string;
    fields: PPField[];
    readOnly: boolean | null;
}

export interface Option {
    label: string;
    value: string;
    readOnly?: boolean;
}

type Direction = 'column' | 'row'

export interface CustomFormProps {
    template: PPFormTemplate,
    data: any,
    hideSave?: boolean;
    visible?: boolean,
    loading?: boolean,
    EditForm?: boolean,
    onClose?: Function,
    model?: any;
    parentCallback?: Function;
    functions?: ButtonEventGrid[];
    header?: string;
    detailButton?: boolean;
    enableNotifications?: boolean;
    setResultData?: Function;
    setError?: Function;
    refreshSeed?: number;
    disableFields?: boolean;
    maxWidth: string;
    maxWidthInternal: string;
    direction?: Direction;
    formStyle?: React.CSSProperties;
    containerStyle?: React.CSSProperties;
    submitted?: boolean
}

export const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
        theme.palette.mode === 'dark'
            ? '0 0 0 1px rgb(16 22 26 / 40%)'
            : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background:
            theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));

export const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#FFB800',
    borderColor: '#FFFFFF',
    borderWidth: '2px',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#FFB800',
    },
});

export const BpCheckedIconDisabled = styled(BpIcon)({
    // backgroundColor: '#FFB800',
    borderColor: '#FFFFFF',
    borderWidth: '2px',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        // backgroundColor: '#FFB800',
        backgroundColor: 'grey',

    },
});

export const PPFormHH: React.FC<CustomFormProps> = (props) => {
    const classes = useStyles();
    useEffect(() => {
        if (props.refreshSeed && props.refreshSeed >> 0) {
            trigger();
            Salvar({});
        }

    }, [props.refreshSeed]);

    const { enqueueSnackbar } = useSnackbar();
    const handleChangeMultiple = (event: React.ChangeEvent<{ value: unknown; }>) => {
        const { options } = event.target as HTMLSelectElement;
        const value: string[] = [];
        if (options instanceof Array)
            for (let i = 0, l = options.length; i < l; i += 1) {
                if (options[i].selected) {
                    value.push(options[i].value);
                }
            }
        else
            event && event.target && value.push(event.target.value as string);
        if (value && value.length == 1) {
            return value[0];
        }
        return value;
    };

    let loading = false;
    if (props && props.loading) {
        loading = props.loading;
    }
    const [errorCount, setErrorCount] = useState<number>(0);
    const [counter, setCounter] = useState<number>(0);
    const [template, setTemplate] = useState(props.template);
    const [data, setData] = useState();

    const { register, handleSubmit, control, watch, formState: { errors }, getValues, setValue,
        trigger } = useForm({
            mode: "all", reValidateMode: 'onChange', criteriaMode: "firstError",
            shouldFocusError: true, defaultValues: props.data, shouldUnregister: true
        });

    const Salvar = (func: any) => {
        if (func.skipvalidation != null && func.skipvalidation == true) {
            executeOperationOnRecord(props, getValues, trigger, func);
            return;
        }

        setErrorCount(0);
        trigger();

        template.fields.map((fieldItem: any) => {
            trigger(fieldItem.name);
        });

        template.fields.map((fieldItem: any) => {

            trigger(fieldItem.name).then(() => {
                props.setError && props.setError(errors);
                if (props.enableNotifications) {
                    if (errors[fieldItem.name] != null) {
                        const count = errorCount + 1;
                        setErrorCount(count);

                        // enqueueSnackbar(errors[fieldItem.name].message , {
                        //     variant: 'error',
                        //     preventDuplicate: true,
                        //     persist: false,
                        //     anchorOrigin: {
                        //         vertical: 'top',
                        //         horizontal: 'center',
                        //     },
                        // });
                    }
                }
            });
        });

        var resultValues = getValues();
        handleSubmit(onSubmit, onError)();
        props.setError && props.setError(errors);
        props.setResultData && props.setResultData(resultValues);
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            var resultValues = getValues();
            trigger();
            //template.fields.map((fieldItem: any) => {
            //    trigger(fieldItem.name);
            //});
            if (data != resultValues) {
                setData(resultValues);
                props.setError && props.setError(errors);
                props.setResultData && props.setResultData(resultValues);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        let interfaceTyped: { [key: string]: any; } = { ...props.data };
        try {
            setTemplate(props.template);
            Object.keys(props.data).map((field) => {
                interfaceTyped = props.data;
                setValue(field, interfaceTyped[field]);
                trigger(field);
            });
        } catch (e) { }
    }, [props.EditForm]);

    if (props == undefined || props == null) {
        return (<div></div>);
    }


    function executeOperationOnRecord(props: React.PropsWithChildren<CustomFormProps>,
        getValues: any,
        trigger: any,
        func: { title: string; icon: string; disabled?: boolean | undefined; func: Function; }) {
        let interfaceTyped: { [key: string]: any; } = { ...props.data };
        let interfaceTypedNewValues: { [key: string]: any; } = { ...getValues() };
        Object.keys(getValues()).map((field) => {
            trigger(field);
            interfaceTyped[field] = interfaceTypedNewValues[field];
        });
        if (func)
            func.func(interfaceTyped);
    }


    const onSubmit = () => {
        if (errorCount == 0) {
            let funca = props && props.functions && props.functions?.filter(x => x.skipvalidation == false)[0];
            props && props.functions && funca && executeOperationOnRecord(props, getValues, trigger, funca);
        }
    };

    const isYesNoOptions = (options) => {
        if (options.length !== 2) {
            return false;
        }
        const sortedOptions = options.map(o => o.value).sort();
        return (sortedOptions[0] === 'Não' && sortedOptions[1] === 'Sim') || (sortedOptions[0] === 'Sim' && sortedOptions[1] === 'Não');
    };
    
    const onError = () => { };
    try {
        return (<>
            {!loading && <div   >
                <div style={{ margin: window.screen.width > 600 ? 0 : '0px 0px 0px 5px', padding: 0 }} >
                    <div className="header" style={{ margin: 0, padding: 0 }} >
                        <Typography variant="h5" color="textPrimary" component="p">{props.header}</Typography>
                    </div>
                    {/*{props.detailButton &&*/}
                    {/*    <div className="sequence" style={{ marginBottom: 6, padding: 0 }} >*/}
                    {/*        {*/}
                    {/*            props.functions &&*/}
                    {/*            props.functions.filter((x: any) => x.disabled != true).map((func, index) => (*/}
                    {/*                <PPIconLink id={func.id} tooltip={func.tooltip} key={index} icon={func.icon}*/}
                    {/*                    onClick={() => { Salvar(func); } } />))*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*}*/}
                    <div className='PPForm'  >
                        <form style={props.formStyle ? props.formStyle : undefined}>
                            <Grid container spacing={0} direction={props.direction} style={props.containerStyle ? props.containerStyle : { flexWrap: (props.direction && props.direction == "column") ? "nowrap" : "wrap" }}>
                                {template.fields.filter((x: { edit: any; add?: any; disabled?: any }) =>
                                    (!x.disabled && ((props.EditForm === true || props.EditForm === undefined)) || (props.EditForm === false)))
                                    .sort((a: { order: number; }, b: { order: number; }) => {
                                        if (a.order > b.order) return 1;
                                        else if (b.order > a.order) return -1;
                                        return 0;
                                    })
                                    .map((field: {
                                        type?: any; title?: any; name?: any; validate?: any; required?: any;
                                        defaultValue?: any; disabled?: any; row?: any; col?: any;
                                        colspan?: number; rowspan?: any; options?: any; formatData?: any; icon?: any;
                                        denpendentFieldFilter?: any, multiselect?: any, edit: boolean;
                                    }, index: number) => {
                                        let { type, title, name, required, disabled,
                                            colspan, formatData, denpendentFieldFilter, multiselect, edit } = field;
                                        let colspanField: GridSize = 2;
                                        if (colspan != undefined) {
                                            colspanField = (colspan * 6) as GridSize;
                                        }
                                        let formatedData = (props.data[name] != null) ? props.data[name] : '';
                                        if (formatData) {
                                            formatedData = formatData(formatedData);
                                        }
                                        { !required && (required = {}); }

                                        switch (type) {
                                            case 'date':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12, marginLeft: window.screen.width > 600 ? '' : '4px' }} >
                                                        <ThemeProvider theme={theme}>
                                                            <Box className="colorFont" style={{ maxWidth: props.maxWidth, }}>
                                                                {/* <Box className="colorFont" style={{ maxWidth: '33vw', }}> */}
                                                                <Grid container>
                                                                    <Grid item xs={12}  >
                                                                        {
                                                                            title && (<Grid container className={classes.label}>
                                                                                <Grid item xs sm md lg xl>
                                                                                    {title}
                                                                                </Grid>

                                                                            </Grid>)
                                                                        }
                                                                        <TextField
                                                                            key={name}
                                                                            type={'date'}
                                                                            multiline={false}
                                                                            // style={{ marginRight: '15px', width: '32vw', maxWidth: "32vw", }}
                                                                            style={{
                                                                                marginRight: '15px',
                                                                                width: props.maxWidthInternal,
                                                                                maxWidth: props.maxWidthInternal,
                                                                                overflow: 'auto',
                                                                                backgroundColor: disabled || props.disableFields ? "#EBEBEB" : "",
                                                                            }}
                                                                            error={errors[name] != null && props.submitted}
                                                                            required={required.value == true}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            className={classes[required.value ? '_required' : 'root']}
                                                                            title={title}
                                                                            variant="outlined"
                                                                            defaultValue={formatedData}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            label={false}
                                                                            {...register(name, { validate: (value) => { return required.value ? (value && value != undefined) ? true : required.required : true; } })}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );
                                                break;
                                            case 'textarea':
                                            case 'textArea':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 }} >
                                                        <ThemeProvider theme={theme}>
                                                            <Box className="colorFont" style={{ maxWidth: props.maxWidth }}>
                                                                {/* <Box className="colorFont" style={{ maxWidth: '33vw', }}> */}
                                                                <Grid container>
                                                                    <Grid item xs={12}  >
                                                                        {
                                                                            title && (
                                                                                <Grid container className={classes.label} style={{ width: props.maxWidthInternal, }}>
                                                                                    <Grid item xs sm md lg xl style={{ width: props.maxWidthInternal, }}>
                                                                                        {title}
                                                                                    </Grid>

                                                                                </Grid>
                                                                            )
                                                                        }
                                                                        <TextField
                                                                            key={name}
                                                                            multiline={true}
                                                                            maxRows={5}
                                                                            style={{
                                                                                marginRight: '15px',
                                                                                width: props.maxWidthInternal,
                                                                                maxWidth: props.maxWidthInternal,
                                                                                overflow: 'auto',
                                                                                marginLeft: window.screen.width > 600 ? '0px' : '4px',
                                                                                maxHeight: '100px',
                                                                                backgroundColor: disabled || props.disableFields ? "#EBEBEB" : "",
                                                                                // width: '32vw',
                                                                                // maxWidth: "32vw",
                                                                            }}
                                                                            error={errors[name] != null && props.submitted}
                                                                            required={required.value == true}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            className={classes[required.value ? 'multiline_required' : 'multiline']}
                                                                            title={title}
                                                                            variant="outlined"
                                                                            defaultValue={formatedData}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            label={false}
                                                                            {...register(name, { validate: (value) => { return required.value ? (value && value != undefined) ? true : required.required : true; } })}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );

                                                break;

                                            case 'file':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} >
                                                        <FormGroup key={`FormGroup${index}`}
                                                            style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 }}
                                                        >
                                                            <InputLabel key={`InputLabel${index}`} error={errors[name] != null ? true : false}
                                                                style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12, margin: 0 }}
                                                                htmlFor="outlined-age-simple">
                                                                {title}
                                                            </InputLabel>
                                                            <TextField
                                                                key={name}
                                                                style={{
                                                                    position: 'relative',
                                                                    paddingLeft: 0,
                                                                    marginLeft: 10,
                                                                    marginRight: 10,
                                                                    paddingRight: 0,
                                                                    paddingTop: 0,
                                                                    left: '-5px',
                                                                    backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                    fontSize: 12,
                                                                    width: props.maxWidthInternal, maxWidth: props.maxWidthInternal,
                                                                    overflow: 'auto',
                                                                    // width: '32vw', maxWidth: "32vw",
                                                                    // maxWidth: "80%"
                                                                }}
                                                                type='file'
                                                                error={errors[name] != null ? true : false}
                                                                required={required.value == true}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                variant="standard"
                                                                size="small"
                                                                defaultValue={formatedData}
                                                                name={name}
                                                                disabled={disabled || props.disableFields || !edit}
                                                                helperText={errors[name] != null ? required.message : ""}
                                                                inputRef={required && register(required)}
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                ); break;
                                            case 'password':
                                                { !required && (required = {}); }
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} >
                                                        <FormGroup key={`FormGroup${index}`}
                                                            style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 }}
                                                        >
                                                            <InputLabel key={`InputLabel${index}`} error={errors[name] != null ? true : false}
                                                                style={{
                                                                    position: 'relative', paddingLeft: 0, marginLeft: 10, marginRight: 10,
                                                                    paddingRight: 0, paddingTop: 0,
                                                                    fontSize: 12, margin: 0
                                                                }}
                                                                htmlFor="outlined-age-simple">
                                                                {title}
                                                            </InputLabel>
                                                            <TextField
                                                                key={name}
                                                                style={{
                                                                    position: 'relative',
                                                                    width: '32vw',
                                                                    maxWidth: props.maxWidthInternal,
                                                                    // maxWidth: "32vw",
                                                                    left: '-5px',
                                                                    backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                    paddingLeft: 0,
                                                                    paddingRight: 0,
                                                                    paddingTop: 0,
                                                                    fontSize: 12,
                                                                    overflow: 'auto',
                                                                    // maxWidth: '80%'
                                                                }}
                                                                type='password'
                                                                error={errors[name] != null ? true : false}
                                                                required={required.value == true}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                size="small"
                                                                defaultValue={formatedData}
                                                                variant="standard"
                                                                name={name}
                                                                inputRef={required && register(required)}
                                                                disabled={props.disableFields || !edit}
                                                            />
                                                        </FormGroup>
                                                    </Grid>
                                                );
                                                break;
                                            case 'checkbox':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12}  >
                                                        <ThemeProvider theme={theme}>
                                                            <Box style={{ maxWidth: props.maxWidth }}>
                                                                {/* <Box style={{ maxWidth: '33vw' }}> */}
                                                                <FormControl key={`FormControl${index}`} error={errors[name] != null ? true : false}
                                                                    component="fieldset"
                                                                    style={{
                                                                        margin: 8,
                                                                        marginTop: 10
                                                                    }} >
                                                                    <FormControlLabel
                                                                        key={`FormControlLabel${index}`}
                                                                        control={
                                                                            <Checkbox
                                                                                disabled={disabled || props.disableFields || !edit}
                                                                                required={required.value == true}
                                                                                defaultChecked={formatedData}
                                                                                {...register(name, { validate: (value) => { return required.value ? (value != undefined) ? true : required.required : true; } })}
                                                                                style={{
                                                                                    color: (props.disableFields) ? "black" : '#FFB800',
                                                                                    backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                                    width: '35px',
                                                                                    height: '28px',
                                                                                    left: '0px',
                                                                                    top: '0px',
                                                                                    flex: 'none',
                                                                                    // margin: '0px 8px',
                                                                                    marginLeft: "-7px",
                                                                                    borderColor: 'white'
                                                                                }}
                                                                                checkedIcon={(props.disableFields) ? <BpCheckedIconDisabled /> : <BpCheckedIcon />}
                                                                                icon={<BpIcon />}
                                                                            />
                                                                        }
                                                                        label={title}
                                                                        style={{ width: props.maxWidthInternal, }}
                                                                    />
                                                                </FormControl>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );
                                                break;
                                            case 'number':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 }} >
                                                        <ThemeProvider theme={theme}>
                                                            <Box className="colorFont" style={{ maxWidth: props.maxWidth }}>
                                                                {/* <Box className="colorFont" style={{ maxWidth: '33vw' }}> */}
                                                                <Grid container>
                                                                    <Grid item xs={12}  >
                                                                        {
                                                                            title && (
                                                                                <Grid container className={classes.label}>
                                                                                    <Grid item xs sm md lg xl>
                                                                                        {title}
                                                                                    </Grid>

                                                                                </Grid>
                                                                            )
                                                                        }
                                                                        <TextField
                                                                            key={name}
                                                                            type={'number'}
                                                                            multiline={true}
                                                                            maxRows={2}
                                                                            style={{
                                                                                marginRight: '15px',
                                                                                width: props.maxWidthInternal,
                                                                                // width: '32vw',
                                                                                // maxWidth: "32vw",
                                                                                maxWidth: props.maxWidthInternal,
                                                                                overflow: 'auto',
                                                                                marginLeft: window.screen.width > 600 ? '0px' : '4px',
                                                                                backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                                maxHeight: '100px'

                                                                            }}
                                                                            error={errors[name] != null && props.submitted}
                                                                            required={required.value == true}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            className={classes[required.value ? '_required' : 'root']}
                                                                            title={title}
                                                                            variant="outlined"
                                                                            defaultValue={formatedData}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            label={false}
                                                                            {...register(name, { validate: (value) => { return required.value ? (value && value != undefined) ? true : required.required : true; } })}
                                                                            size="small"

                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );
                                                break;
                                            case 'text':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} style={{
                                                        position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12,
                                                        marginLeft: window.screen.width > 600 ? '' : '4px'
                                                    }} >
                                                        <ThemeProvider theme={theme}>
                                                            <Box className="colorFont" style={{ maxWidth: props.maxWidth }}>
                                                                {/* <Box className="colorFont" style={{ maxWidth: '33vw' }}> */}
                                                                <Grid container>
                                                                    <Grid item xs={12}  >
                                                                        {
                                                                            title && (<Grid container className={classes.label} style={{ width: props.maxWidthInternal, }}>
                                                                                <Grid item xs sm md lg xl style={{ width: props.maxWidthInternal, }}>
                                                                                    {title}
                                                                                </Grid>

                                                                            </Grid>)
                                                                        }
                                                                        <TextField
                                                                            key={name}
                                                                            multiline={true}
                                                                            maxRows={3}
                                                                            style={{
                                                                                marginRight: '15px',
                                                                                width: props.maxWidthInternal,
                                                                                maxWidth: props.maxWidthInternal,
                                                                                overflow: 'auto',
                                                                                backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                                maxHeight: '100px'
                                                                                // width: '32vw',
                                                                                // maxWidth: "32vw",
                                                                            }}
                                                                            error={errors[name] != null && props.submitted}
                                                                            required={required.value == true}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            className={classes[required.value ? '_required' : 'root']}
                                                                            title={title}
                                                                            variant="outlined"
                                                                            defaultValue={formatedData}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            label={false}
                                                                            {...register(name, { validate: (value) => { return required.value ? (value && value != undefined) ? true : required.required : true; } })}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );
                                                break;
                                            case 'money':
                                                return (
                                                    <Grid key={`Grid${index}`} item sm={colspanField} xs={12} style={{ position: 'relative', paddingLeft: 0, paddingRight: 0, paddingTop: 0, fontSize: 12 }} >
                                                        <ThemeProvider theme={theme}>
                                                            {/* <Box className="colorFont" style={{ maxWidth: '33vw' }}> */}
                                                            <Box className="colorFont" style={{ maxWidth: props.maxWidth }}>
                                                                <Grid container>
                                                                    <Grid item xs={12}  >
                                                                        {
                                                                            title && (<Grid container className={classes.label}>
                                                                                <Grid item xs sm md lg xl>
                                                                                    {title}
                                                                                </Grid>
                                                                            </Grid>)
                                                                        }

                                                                        <TextField
                                                                            key={name}
                                                                            multiline={true}
                                                                            style={{
                                                                                marginRight: '15px',
                                                                                // width: '32vw',
                                                                                // maxWidth: "32vw",
                                                                                width: props.maxWidthInternal,
                                                                                maxWidth: props.maxWidthInternal,
                                                                                overflow: 'auto',
                                                                                backgroundColor: disabled || props.disableFields ? "#EBEBEB" : '#FFFFFF',
                                                                            }}
                                                                            error={errors[name] != null && props.submitted}
                                                                            required={required.value == true}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            className={classes[required.value ? '_required' : 'root']}
                                                                            title={title}
                                                                            variant="outlined"
                                                                            defaultValue={formatedData}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            label={false}
                                                                            {...register(name, { validate: (value) => { return required.value ? (value && value.lenght > 0) ? true : required.required : true; } })}
                                                                            size="small"
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                );
                                                break;
                                            case 'select': {
                                                let { options: options } = field;
                                                try {
                                                    if (denpendentFieldFilter) {
                                                        options = denpendentFieldFilter.filter(getValues());
                                                    }

                                                    //if (options && options.length == 1) {

                                                    //   // setValue(name, options[0].value);
                                                    //    //trigger(name);
                                                    //}

                                                } catch (e) {

                                                }

                                                let value = getValues(name);
                                                const initialValue = value === 'Sim';

                                                return ((options && options.length > 0) && props.visible &&

                                                    <Grid key={`Grid${index}`} item style={isYesNoOptions(options) ? { minHeight: '65px', display: 'flex', alignItems: 'center' } : {}} sm={colspanField} xs={12}>
                                                        <Controller
                                                            control={control}
                                                            name={name}
                                                            rules={{
                                                                validate: () => {
                                                                    return ((required.value ? (getValues(name) != "-1" && getValues(name) != undefined) ? true : required.required : true));
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <Box className="colorFont" style={{ marginTop: "-6px", marginLeft: '0px', width: props.maxWidth, maxWidth: props.maxWidth, }}>
                                                                    {/* <Box className="colorFont" style={{ marginTop: "-6px", marginLeft: "-5px", width: '33vw', maxWidth: "33vw", }}> */}
                                                                    {isYesNoOptions(options) ?
                                                                        (value === undefined && setValue(name, 'Não'),
                                                                            <PPToggle
                                                                                toggled={initialValue}
                                                                                name={name}
                                                                                title={title.replace("(Obrigatório)", "")}
                                                                                disabled={disabled || props.disableFields || !edit}
                                                                                onChange={(event) => {
                                                                                    const newValue = event.checked ? 'Sim' : 'Não';
                                                                                    setValue(name, newValue);
                                                                                    trigger(name);
                                                                                }}
                                                                            />) :
                                                                        <PPDropDown
                                                                            {...field}
                                                                            openTrigger={'click'}
                                                                            error={{
                                                                                show: (errors[name] != null && (props.submitted || false)),
                                                                                help: 'error'
                                                                            }}
                                                                            key={name}
                                                                            onChange={val => {
                                                                                let values = handleChangeMultiple(val);
                                                                                setValue(name, values);
                                                                                trigger(name);
                                                                                let count = counter;
                                                                                count = count + 1;
                                                                                setCounter(count);
                                                                            }}
                                                                            disabled={disabled || props.disableFields || !edit}
                                                                            options={options}
                                                                            required={required.value == true}
                                                                            // defaultValue={formatedData} 
                                                                            placeholder="Preencha aqui"
                                                                            placeholderSearch={`Buscar ${title}`}
                                                                            title={title}
                                                                        //j
                                                                        >
                                                                        </PPDropDown>}
                                                                </Box>
                                                            )}
                                                        />

                                                    </Grid>
                                                );
                                            }
                                                break;
                                            default:
                                                return (
                                                    <div key={`di${index}`}>
                                                        <span>Invalid Field</span>
                                                    </div>
                                                );
                                        }
                                    })}
                            </Grid>
                        </form>
                        {
                            props.children &&
                            <div key={'Extra'}>{props.children}</div>
                        }
                    </div>
                    {
                        props.detailButton &&
                        <Grid className="topbar" style={{ margin: 0, padding: 0 }} >
                            <Grid className="functions" style={{ marginBottom: 6, padding: 0 }} >
                                {
                                    props.functions &&
                                    props.functions.filter((x: any) => x.disabled != true).map((func, index) => {
                                        return (
                                            <button id={func.id} key={index}
                                                onClick={() => { Salvar(func); }}
                                                className="lc-button bg-primary mr-5" >{func.title}</button>);
                                    })
                                }
                            </Grid>
                        </Grid>
                    }
                </div>

            </div>
            }
        </>);
    } catch (e) {
        return (<></>);
    }


};
